import { Component, OnInit, ViewChild } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { toJSDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddemppopComponent } from '../../emp/addemppop/addemppop.component';
import { EditpayrolldetComponent } from '../editpayrolldet/editpayrolldet.component';
import { PayslipComponent } from '../payslip/payslip.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ExcelService } from 'src/app/services/services/excel.service';

@Component({
  selector: 'app-addpayroll',
  templateUrl: './addpayroll.component.html',
  styleUrls: ['./addpayroll.component.css']
})
export class AddpayrollComponent implements OnInit {

  @ViewChild('payrolllinebar', { static: false }) payrolllinebar;
  @ViewChild('payslipbar', { static: false }) payslipbar;


  formname: string = "Payroll";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isviewpayrolldetails: boolean = false;
  isviewpayslipdetails: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;


  payrollform = new FormGroup({
    payrollid: new FormControl(0),
    payperiod: new FormControl('', Validators.required),
    startdt: new FormControl('', Validators.required),
    enddt: new FormControl('', Validators.required),
    payrollgrpid: new FormControl(null, Validators.required),
    branchid: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  payrollColl: any = [];
  payrollid: number = 0
  gpayrollid: number = 0

  payrollBO: any = [];

  sponserid: any = null;
  branchid: any = null;
  branchColl: any = [];
  payrollgrpColl: any = [];
  payrollgrpallColl: any = [];

  private gridApi;
  private gridColumnApi;

  columnDefs = []

  gridOptions = {
    rowSelection: 'single',
    rowHeight: 40,
    columnDefs: this.columnDefs,
    defaultColDef: {
      resizable: true, floatingFilter: true,
      flex: 1,
      width: 100,
      minWidth: 100,
      sortable: true,
      filter: true,
    },
  };

  searchtxt: string = "";

  private setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }

  constructor(private appService: AppdataService, private excelService: ExcelService, public loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.payrollid = params.id
      }
    });
    this.fnServiceChanges();
  }



  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.payrollform.reset();
      this.fnInitializeFormGroup();

      if (this.payrollid > 0) {
        this.fngetPayRollByPayRollid();
      }


      this.fngetBranch();
      this.fngetPayRollGrp();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.payrollid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }




  fnInitializeFormGroup() {
    this.payrollform.setValue({
      payrollid: 0,
      payperiod: '',
      startdt: null,
      enddt: null,
      payrollgrpid: null,
      branchid: null,
      inactive: false
    })
  }


  //Grid
  fnGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }




  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetPayRollGrp() {
    var data = {
      'payrollgrpid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPayrollgrp(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollgrpColl = res.json().result;


          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetPayRollByPayRollid() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'payrollid': this.payrollid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetPayRollByPayrollid(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            var result = res.json().result;
            var payrollmainColl = result[0];
            var editdata = payrollmainColl[0];
            this.payrollBO = editdata;
            this.fnEditMode(editdata);

            this.payrollColl = result[1];
            this.columnDefs = this.generateColumns(this.payrollColl);

            this.payrollgrpallColl = result[1];

            this.fnSetTable();

          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  //Event  
  fnActionEditClick() {

    if (!this.gridApi) {
      return;
    }

    if (this.gridApi.getSelectedRows().length > 0) {
      var data = this.gridApi.getSelectedRows()[0];
      // const modalRef = this.productFindService.open(EditpayrolldetComponent, { size: <any>'xl' });
      // modalRef.componentInstance.payrollid = this.gpayrollid;
      // modalRef.componentInstance.empid = data.empid;
      // modalRef.componentInstance.empname = data.Employee;
      // modalRef.componentInstance.fngetPayrolldetails();

      // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      //   if (receivedEntry === 'DONE') {

      //   }
      // }); 

      this.payrolllinebar.payrollid = this.gpayrollid;
      this.payrolllinebar.empid = data.empid;
      this.payrolllinebar.empname = data.Employee;
      this.payrolllinebar.fngetPayrolldetails();

      this.isviewpayrolldetails = true;

    }


  }

  fnActionFilterClick() {

    this.isviewpayrolldetails = false;
    this.isviewpayslipdetails = false;

    // if (this.payrollid > 0) {
    //   this.fngetPayRollByPayRollid();
    // }
  }


  fnPayrollDetailsChanges(event) {

    if (this.payrollid > 0) {
      this.fngetPayRollByPayRollid();
    }
  }



  fnActionPaySlipClick() {
    if (!this.gridApi) {
      return;
    }

    if (this.gridApi.getSelectedRows().length > 0) {
      var data = this.gridApi.getSelectedRows()[0];
      const modalRef = this.productFindService.open(PayslipComponent, { size: <any>'xxl' });
      modalRef.componentInstance.payrollid = this.gpayrollid;
      modalRef.componentInstance.empid = data.empid;
      modalRef.componentInstance.empname = data.Employee;
      modalRef.componentInstance.fngetPayrolldetails();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        if (receivedEntry === 'DONE') {

        }
      });


      // this.payslipbar.payrollid = this.gpayrollid;
      // this.payslipbar.empid = data.empid;
      // this.payslipbar.empname = data.Employee;
      // this.payslipbar.fngetPayrolldetails();

      //this.isviewpayslipdetails = true;

    }
  }

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'payrolllist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
    this.gridApi.exportDataAsCsv(params);
  }



  //Save Btn Click
  fnGenerateBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.payrollform.valid) {
        //Check
        var data = {
          'payrollid': this.payrollid,
          'payperiod': this.payrollform.get('payperiod').value,
          'startdt': this.fnFormatDatetime(this.payrollform.get('startdt').value),
          'enddt': this.fnFormatDatetime(this.payrollform.get('enddt').value),
          'branchid': this.payrollform.get('branchid').value,
          'payrollgrpid': this.payrollform.get('payrollgrpid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.fngetPayRollGenerate(data);

      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnSaveBtnClick() {

  }


  //Get
  fngetPayRollPeriod() {

    var data = {
      companyid: this.loginService.fnGetCompanyId()
    }
    this.appService.fngetPayRollPeriod(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            var _row: any = null;

            if (res.json().result.length > 0) {
              _row = res.json().result[0];
            }

            if (_row) {
              if (_row.checkstatus === 'DONE') {
                _row.fromdate = this.fnConvertDatetime(this.fnFormatDatetime(_row.fromdate));
                _row.todate = this.fnConvertDatetime(this.fnFormatDatetime(_row.todate));

                this.payrollform.patchValue({
                  payperiod: _row.periodname,
                  startdt: _row.fromdate,
                  enddt: _row.todate,
                });
              }
            }






          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetPayRollGenerate(data) {

    this.appService.fngetPayRollGenerate(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {

            var payrollDet = res.json().result[0];
            this.payrollColl = res.json().result[1];



            if (payrollDet.length > 0) {
              this.gpayrollid = payrollDet[0].payrollid;
            }


            this.columnDefs = this.generateColumns(this.payrollColl);




            this.fnSetTable();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  generateColumns(data: any[]) {
    let columnDefinitions = [];

    data.map(object => {

      Object
        .keys(object)
        .map(key => {

          let mappedColumn = {
            headerName: key.toUpperCase(),
            field: key,
            pinned: key.toUpperCase() == 'EMPLOYEE' || key.toUpperCase() == 'CODE' ? 'left' : key.toUpperCase() == 'TOTAL SALARY' ? 'right' : '',
            width: key.toUpperCase() == 'EMPLOYEE' ? 260 : 150,
            minWidth: 150,
            valueFormatter: key.toUpperCase() != 'EMPLOYEE' && key.toUpperCase() != 'PAID DAYS' && key.toUpperCase() != 'CODE' ? this.fnFormatDecimal : '',
            hide: key.toUpperCase() === 'BRANCHID' || key.toUpperCase() === 'SPONSERID' ? true : false,
          }

          if (key != 'empid') {
            columnDefinitions.push(mappedColumn);
          }

        })
    })
    //Remove duplicate columns
    columnDefinitions = columnDefinitions.filter((column, index, self) =>
      index === self.findIndex((colAtIndex) => (
        colAtIndex.field === column.field
      ))
    )
    return columnDefinitions;
  }


  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Payroll']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  private fnEditMode(deptBO) {
    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));

    this.payrollform.setValue({
      payrollid: deptBO.payrollid,
      payperiod: deptBO.payperiod,
      startdt: deptBO.startdt,
      enddt: deptBO.enddt,
      payrollgrpid: deptBO.payrollgrpid,
      branchid: deptBO.branchid,
      inactive: deptBO.inactive
    });

    this.gpayrollid = deptBO.payrollid;

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnSetTable() {
    if (this.gridApi) {
      //  this.gridApi.sizeColumnsToFit();

      // var allColIds = this.gridColumnApi.getAllColumns()
      //     .map(column => column.colId);
      //     this.gridColumnApi.autoSizeColumns(allColIds);

      // // If you want to resize all columns
      // this.gridColumnApi.autoSizeAllColumns();


    }

    // if (this.gridApi) {
    //   this.gridApi.sizeColumnsToFit();     
    // }
  }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.payrollid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetPayRollByPayRollid();
      }


    });
  }

  public fnSearchDatatable(value) {
    this.gridApi.setQuickFilter(value);
  }

  createData() {
    var result = [];

    return result;
  }



  //Get 
  fnGenerateWPS() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'payrollid': this.payrollid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fnGetPayrollWPSFormat(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            var result = res.json().result;
            var formatstr = "";



            if (result.length > 0) {
              formatstr = result[0].wpsfiletxt
            }

            this.dyanmicDownloadByHtmlTag({
              fileName: 'WPSFile',
              text: JSON.stringify(formatstr)
            });



          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  private dyanmicDownloadByHtmlTag(arg: {
    fileName: string,
    text: string
  }) {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);

    var event = new MouseEvent("click");
    element.dispatchEvent(event);
  }


  fnFilterBranch() {


    this.payrollColl = this.payrollgrpallColl;

    if (this.branchid > 0) {
      this.payrollColl = this.payrollColl.filter(abo => {
        return abo.branchid == this.branchid
      });
    }

    if (this.sponserid > 0) {
      this.payrollColl = this.payrollColl.filter(abo => {
        return abo.sponserid == this.sponserid
      });
    }

    this.columnDefs = this.generateColumns(this.payrollColl);


  }

  private fnExport() {

    var filter = [
      "Start Date :" + this.fnFormatDatetime(this.payrollform.get('startdt').value)+" "+ "End Date :"+this.fnFormatDatetime(this.payrollform.get('enddt').value),
     
    ]

    var data = {
      data: this.payrollColl,
      columnDefs: this.columnDefs,
      title: 'Pay Roll Report',
      filter:filter
    };


    this.excelService.generateExcel(data);


  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  fnFormatDecimal(params) {
    if (params.value) {
      return params.value.toFixed(2)
    }
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
